import Vue from 'vue'
import Vuex from 'vuex'
import { transformObjectToOptionList } from '../plugins/dataService.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    setting: {
      title: {}
    },
    isMobile: false
  },
  mutations: {
    setSetting (store, payload) {
      store.setting = payload;
    },
    setIsMobile (state, isMobile) {
      state.isMobile = isMobile;
    }
  },

  getters: {
    setting: (state) => state.setting || {},
    isMobile: (state) => state.isMobile,
    footerOffice: (state) => state.setting?.footer?.office || [],
    footerContact: (state) => state.setting?.contact?.about_us || [],
    footerLogo: (state) => state.setting?.footer?.certificate || [],
    contactCompany: (state) => state.setting?.contact?.company || {},
    contact: (state) => state.setting?.contact?.letting?.detail || {},
    otherService: (state) => state.setting?.other_service || [],
    optionPrice: (state) => {
      const list = state.setting.pirce || [];
      return list.map((obj) => {
        const kv = Object.entries(obj)[0];
        return {
          name: kv[1],
          value: kv[0]
        }
      });
    },
    optionTypeList: (state) => transformObjectToOptionList(state.setting.property_type),
    optionCityList: (state) => transformObjectToOptionList(state.setting.city),
    optionTitleList: (state) => transformObjectToOptionList(state.setting.title),
    optionRoomList: (state) => transformObjectToOptionList(state.setting.bedroom),
    optionAreasList: (state) => transformObjectToOptionList(state.setting.areas_of_interests),
  }
})
